import styled from 'styled-components'
import { Box as MuiBox } from '@material-ui/core'

export const Box = MuiBox

export const MainBox = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const RowsBox = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const AddButtonBox = styled(Box)`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  justify-content: flex-end;
  padding: 1rem;
`

export const SlideCountLabel = styled.span<{ atMax: boolean }>`
  font-size: 0.8rem;
  color: ${({ atMax }) => (atMax ? '#e53e3e' : '#888')};
  font-weight: ${({ atMax }) => (atMax ? '600' : '400')};
  white-space: nowrap;
`
